export const blank = () =>
  import(
    /* webpackChunkName: "studioPresets-blank" */ './definitions/blank.json'
  )
export const news = () =>
  import(/* webpackChunkName: "studioPresets-news" */ './definitions/news.json')
export const projects = () =>
  import(
    /* webpackChunkName: "studioPresets-projects" */ './definitions/projects.json'
  )
export const team = () =>
  import(/* webpackChunkName: "studioPresets-team" */ './definitions/team.json')
export const portfolio = () =>
  import(
    /* webpackChunkName: "studioPresets-portfolio" */ './definitions/portfolio.json'
  )
export const edit = () =>
  import(/* webpackChunkName: "studioPresets-edit" */ './definitions/edit.json')
